import {PhoneHQAvatar} from "ch3-ui-lib";
import {getUserStatus} from "../../utilis/getStatus.ts";
import {UserDirectoryItem} from "../../pages/Chat/Chat.tsx";
import {UserStatus} from "../../store/features/Team/teamService.ts";

interface NewRoomItemProps {
    user: UserDirectoryItem
    isSelected: boolean;
    onClick: () => void;
    status: UserStatus | undefined;
}
export const NewRoomItem = ({user, isSelected, onClick, status}: NewRoomItemProps) => {

    return (
        <button
            onClick={onClick}
            className={`w-[324px] text-left rounded-lg transition-colors relative ${
                isSelected
                    ? 'bg-surface-muted' : 'hover:bg-surface-muted'}`}
        >
            <div className="flex items-center space-x-3 p-3">
                <div className="w-10 h-10 flex items-center justify-center text-white font-medium relative">
                    {

                            <PhoneHQAvatar size={'32px'} name={user.display_name}
                                           status={getUserStatus(status)}
                                           src={user?.avatar_url || undefined}/>
                    }
                </div>

                <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between">
                        <p className={`truncate text-sm font-medium text-ink`}>
                            {user.display_name}
                        </p>
                    </div>



                </div>

            </div>

        </button>
    );
}